import { createReducer, on } from '@ngrx/store';

import {
  addDevice,
  deleteDevice,
  loadDeviceModelsSuccess,
  loadDevicesSuccess,
  updateDevice,
} from '@store/actions/devices.actions';
import { deviceAdapter, initialDeviceState } from '@store/state/devices.state';

export const deviceReducer = createReducer(
  initialDeviceState,
  on(loadDevicesSuccess, (state, { devices }) => {
    return deviceAdapter.setAll(devices, state);
  }),
  on(loadDeviceModelsSuccess, (state, { deviceModels }) => {
    return {
      ...state,
      deviceModels,
    };
  }),
  on(addDevice, (state, { device }) => deviceAdapter.addOne(device, state)),
  on(updateDevice, (state, { device }) =>
    deviceAdapter.updateOne({ id: device.id, changes: device }, state),
  ),
  on(deleteDevice, (state, { id }) => deviceAdapter.removeOne(id, state)),
);
